<template>
	<div>
		<template v-if="pageshow">
			<!-- 商机列表 -->
			<template v-if="isearch && !glopertype">
				<listheader @settable="setfntable" @uprenew="uprenew" @screen="fn_screen" ref="refader"
					 :one_selectlist="chance_state"  :two_selectlist="statelist" title="商机列表" :localoperate="localviewOperate"
					:types="8" :vieid="6" @exportclick="exportclick" @importclick="importclick" @createclick="createclick"
					:is_recycle.sync="is_recycle" :recyclebin="true" :filter_items="filterpuplist" :sortlist="sortlist">
				</listheader>
			</template>
			<!-- 列表 -->
			<div class="table_box style2" v-loading="table_loading" v-show="!glopertype">
				<!--  -->
				<!-- datapage   --> 
				<tabcontainer :ischecks="false" :list.sync="datapage.list" :total.sync="datapage.total"
					:pagesize.sync="datapage.pagesize" :page.sync="datapage.page" :surplus="surplus" @returow="showDetails"
					@retucheck="(e) => { check_list = e.val;}" @changesize="modify_pagesize" @changepage="switch_page">
					<!--  -->
					<template slot="body">
						<!--  -->
						<el-table-column align="center" type="selection" width="50"></el-table-column>
						<!--  -->
						<el-table-column show-overflow-tooltip :width="item.width" align="left" :prop="item.prop" :label="item.name"
							v-for="(item, index) in tableColumn">
							<template v-slot="scope" v-if="item.name == '商机预算'">
								<span v-if="scope.row.budget">
									￥{{scope.row.budget}}
								</span>
							</template>
						</el-table-column>
						<!--  -->
					</template>
					<!--  -->
					<!--  -->
					<template slot="tabtns">
						<div v-show="is_recycle == 0">
							<el-button @click="custom_click(1)" class="color1" :disabled="check_list.length == 0">转让商机
							</el-button>
							<el-button @click="custom_click(2)" class="color1" :disabled="check_list.length == 0">添加协作人
							</el-button>
							<el-button @click="custom_click(3)" class="color1" :disabled="check_list.length == 0">删除商机
							</el-button>
						</div>
						<div v-show="is_recycle == 1">
							<el-button @click="custom_click(4)" class="color1" :disabled="check_list.length == 0">彻底删除
							</el-button>
						</div>
					</template>
					<!--  -->
				</tabcontainer>
				<!--  -->
			</div>
			<!-- 新建，编辑 -->
			<newbullet :title="billet_tit" :loading="!createPup" :isshow.sync="createPup" :classlist="classlist"
				:fieldlist="field_create" @saveer="fnCreateSave" :savenew="savenew"></newbullet>
			
			<!-- 详情划窗  -->
			<detailspup ptitle="商机信息" :types="6" :dinfo="currentDetail_info" :isshow.sync="drawer_show" :loading="drawer_loading"
				:classlist="classlist" :fieldlist="field_details" :memberlist="memberlist"
				:content_id="drawer_info.chance_id" :is_recycle.sync="is_recycle" :prodlist="product_obj.list"
				:enclist="enclosure.list" :powerobj="powerobj" :stablelist="stablelist"
				@update="fn_update" @btnClick="btnClick" @switchState="switchState"
				@saveproduct="saveproduct" @setupfile="setupfile"
				>
				<template slot="headselect">
					<div class="detail_selChange Flexalign">
						<div class="sel_item Flexalign"> 
						
							<el-select v-model="Detail_scre1" @change="setChanges($event, 1)">
								<el-option v-for="item in chance_state" :label="item.name" :value="item.id">
									{{ item.name }}
								</el-option>
							</el-select>
						</div> 
						<div class="sel_item Flexalign">
							<el-select v-model="Detail_scre2" @change="setChanges($event, 2)">
								<el-option v-for="item in statelist" :label="item.name" :value="item.id">
									{{ item.name }}
								</el-option>
							</el-select>
						</div>
					</div>
				</template>
			</detailspup>
			<!-- 转让，添加协同人 弹出   -->
			<collaborator :show.sync="collab_show" :types="BatchType" :checklist="assistantChecklist"
				:dialogname="dialogname" @success="headaddxzr">
			</collaborator>
			<!--  -->
			<!-- 写跟进  -->
			<writefollow :show.sync="write_show" :customer_obj="customer_obj" @addsuccess="addsuccess"
				:chance_obj="chance_obj"></writefollow>
			<!--  -->
			<!-- 转合同 -->
			<convertarea :types="1" :turndata="turndata" :isload.sync="turnisload" :singleval="chance_obj"
				:memberlist="memberlist"></convertarea>
		</template>
		<template v-else>
			<!-- 不能显示该页面 -->
			<notopened></notopened>
		</template>
	</div>
</template>

<script>
	import {
		deepEqual,
		deepStrs,
		fn_retjson,
		retJSONArr,
		Basics_field,
		contrastDaily,
		headleTime,
		fn_findeditid,
		formatCurrency,
		fn_Judgmentbtn,
		saleconditions,
	} from "network/defaults";
	import {
		fnCustomPage,
		getMumberUser,
		exportExcel,
		fn_getother,
		retujudpower,
		retupower,
		fn_fielddisabled,
	} from "network/kh_public";
	import {
		ToggleTime,
		add_business_chance,
		edit_businchance,
		del_business_chance,
		sj_recyclechance,
		fn_newfield,
		gchance_list,
		getstatusList,
		Chance_details,
		getgroupList,
		getBusinesslist,
		batch_edithance,
	} from "network/hk_operset";
	// 页面头部
	import listheader from "@/components/tabulation/listheader.vue";
	// 新建，编辑推出
	import newbullet from "../components/newpup/newbullet.vue"
	// 详情推出
	import detailspup from "../components/newpup/detailspup.vue"
	// 表格区域
	import tabcontainer from "@/components/tabledata/tabcontainer.vue";
	// 负责人 图标
	import personer from "@/components/tabledata/personer.vue";
	// 添加协同人, 转让 弹出
	import collaborator from "@/components/tabulation/collaborator.vue";
	// 写跟进
	import writefollow from "@/components/integrated/writefollow.vue";
	// 转合同 转换
	import convertarea from "../components/newpup/convertarea.vue"
	import notopened from "@/components/tabledata/notopened.vue";
	import {mix_built} from "@/mixins/builtClick.js"
	export default {
		mixins: [mix_built],
		components: {
			listheader,
			tabcontainer,
			newbullet,
			detailspup,
			personer,
			collaborator,
			writefollow,
			convertarea,
			notopened,
		},
		props: {
			isearch:{
				type: Boolean,
				default: true,
			},
			searchname: {
				type: String,
				default: '',
			},
			searchshow: {
				type: Boolean,
				default: true,
			},
			Sreachmember: {
				type: Array,
				default: ()=>{
					return []
				},
			},  
			// 关联访问
			glopertype: {
				type: Number,
				default: 0,
			},
			cid: {
				type: Number | String,
				default: 0,
			},
			
		},
		watch: {
			drawer_show() { 
				if (!this.drawer_show) {  // 详情划窗关闭
					this.clear_drawer()
					if(this.glopertype) {
						this.$emit('accessclose')
					}
				}
			},
			createPup(){
				if(!this.createPup && this.glopertype) {
					this.$emit('accessclose')
				}
			},
			is_recycle() {  // 回收站
				this.fn_tabledata()
			},
			searchshow(){
				if(this.searchshow) {
					this.setSearchpage();
				}
			},
		},
		created() {
			if(this.isearch){
				this.getMumberList()
			}
			// 基础页面设置
			this.setpageDefault()
			// 关联访问设置
			this.Associated_Access()
			this.surplus = this.$store.state.surplus
		},
		methods: {
			
			Associated_Access(){
				if(this.glopertype) {
					this.currentpup_id = this.$fn_retjson(this.cid) || ''
					this.fn_getDelait()
				}
				else {
					this.surplus = this.$store.state.surplus
				}
			},
			setSearchpage(){
				let val = (this.searchname + '').trim()
				if(val) {
					this.search_name = val
					this.fn_tabledata();
				}
				this.memberlist = fn_retjson(this.Sreachmember)
			},
			setpageDefault() {  // 设置页面默认数据
				// 获取当前页面是否能正常显示
				this.pageshow = fn_getother("商机管理");
				// 获取页码
				let cobj = fnCustomPage("business_chance");
				let pageasize = cobj.page ? cobj.page : 50;
				this.customPageSize = pageasize;
				this.datapage.pagesize = pageasize;
				this.sort_type = cobj.sort || 1; // 排序
				// 获取页面权限
				this.is_powerAdd = retupower("107");
				this.is_powerEdit = retupower("108");
				this.is_powerDel = retupower("109");
				this.is_powerImp = retupower("110");
				this.is_powerExp = retupower("111");
				this.is_powerRec = retupower("112");
				this.powerobj = {
					is_powerAdd: retupower("107"),
					is_powerEdit: retupower("108"),
					is_powerDel: retupower("109"),
					is_powerImp: retupower("110"),
					is_powerExp: retupower("111"),
					is_powerRec: retupower("112"),
				}
			},
			// 添加协同人，转让；返回 成员id 对象res
			headaddxzr(e) {
				if (!retujudpower(this.is_powerEdit)) return;
				if (e) {
					let list = [];
					if (this.batch_edit) {
						list = this.check_list;
					} else {
						list.push(this.drawer_info);
					}
					if (e.types == 1) { // 转让
						this.transferthe(e.member_id, list, 1);
					} else if (e.types == 2) { // 添加协同人
						this.transferthe(e.member_arr, list, 2);
					}
				}
			},
			// 转让 变更负责人 \ 添加协同人
			transferthe(member, list, flag) {
				if (list.length == 0) return
				let edit_info = []
				let fd = new FormData();
				for (let item of list) {
					let detail_info = retJSONArr(item.business_info)
					let ele = {
						chance_id: item.chance_id,
					}
					if (flag == 1) { // 负责人
						let index_1 = detail_info.findIndex(v => v.field_sign == "负责人");
						if (index_1 != -1) {
							detail_info[index_1].content = member;
							ele.member_id = member
						}
					} else if (flag == 2) { // 协同人 
						let index_2 = detail_info.findIndex((v) => v.field_sign == "协同人");
						if (index_2 != -1) {
							if (member.length) {
								detail_info[index_2].content = member.join(",") + ",";
							} else {
								detail_info[index_2].content = "";
							}
						}
						if (member.length) {
							ele.assistant_member_id = member.join(",") + ","; // 否	int	成员id
						} else {
							ele.assistant_member_id = "";
						}
					}
					ele.business_info = JSON.stringify(detail_info)
					edit_info.push(ele);
				}
				fd.append("edit_info", JSON.stringify(edit_info));
				if (flag == 1) {
					fd.append("type", 4);
				}
				batch_edithance(fd).then((res) => {
					if (this.$handlereq(res)) {
						this.$alertMess("修改成功");
						this.drawer_show = false;
						this.collab_show = false;
						this.batch_edit = false
						this.fn_tabledata();
					}
				});
			},
			// 添加跟进成功
			addsuccess() {
				this.fn_update()
				this.write_show = false;
			},
			// 详情推窗单个操作
			btnClick(e) {
				let {
					flag
				} = e
				
				if (flag == 1) { // 新建跟进
					if (!retujudpower(this.is_powerAdd)) return;
					
					this.write_show = true
					this.customer_obj = {
						id: this.drawer_info.customer_id || "",
						name: this.drawer_info.customer_name || "",
					}
				} else if (flag == 2) { // 转合同
					if (!retujudpower(this.is_powerAdd)) return;
					this.turnisload = true
				} else if (flag == 3) { // 编辑
					this.fn_editdatas()
				} else if (flag == 4) { // 恢复 sj_recyclechance
					this.rehighseas(this.currentpup_id)

				} else if (flag == 5) { // 彻底删除
					this.cddel_business(this.currentpup_id)
				}
			},
			// 详情推窗单个下拉操作
			switchState(e) {
				let {
					flag
				} = e
				this.batch_edit = false
				this.assistantChecklist = [];
				if (flag == 1) { // 转让 
					this.collab_show = true;
					this.BatchType = 1;
					this.dialogname = "转让商机";
					let member_id = this.drawer_info.member_id || '';
					this.assistantChecklist.push(member_id);
					
				} else if (flag == 2) { // 添加协同人
					this.collab_show = true;
					this.BatchType = 2;
					this.dialogname = "添加协作人";
					let assistant_Str = this.drawer_info.assistant_member_id || '';
					if (assistant_Str && typeof assistant_Str == "string") {
						let arr = assistant_Str.split(",");
						for (let item of arr) {
							if (item) {
								let member_id = item * 1;
								this.assistantChecklist.push(member_id);
							}
						}
					}
				} else if (flag == 3) { // 删除 回收站
					this.rehighseas(this.currentpup_id, 1)
				}
			},
			// 批量按钮点击
			custom_click(flag) {
				let list = this.check_list;
				if (list.length == 0) return;
				this.batch_edit = true;
				let newArr = [];
				for (let item of list) {
					newArr.push(item.chance_id);
				}
				let delstr = newArr.join(",")
				if (flag == 1) { // 转让
					this.collab_show = true;
					this.BatchType = 1;
					this.dialogname = "转让商机";
				} else if (flag == 2) { // 添加协作人
					this.collab_show = true;
					this.BatchType = 2;
					this.dialogname = "添加协作人";
				} else if (flag == 3) { // 删除
					this.rehighseas(delstr, 1)
				} else if (flag == 4) { // 彻底删除
					this.cddel_business(delstr)
				}
			},
			// 彻底删除
			cddel_business(ids) {
				if (!retujudpower(this.is_powerDel)) return;
				this.$confirm("您确定要删除吗?")
					.then(() => {
						del_business_chance(ids).then((res) => {
							if (this.$handlereq(res)) {
								this.$alertMess("删除成功");
								this.fn_tabledata();
								this.drawer_show = false;
							}
						});
					})
					.catch(() => {});
			},
			// 
			rehighseas(ids, flag) {
				if (flag == 1) { // 删除到回收站
					if (!retujudpower(this.is_powerDel)) return;
					this.$confirm("您确定要删除吗?")
						.then(() => {
							sj_recyclechance(ids, 1).then((res) => {
								if (this.$handlereq(res)) {
									this.$alertMess("删除成功");
									this.fn_tabledata();
									this.drawer_show = false;
								}
							});
						})
						.catch(() => {});
				} else { // 恢复
					if (!retujudpower(this.is_powerEdit)) return;
					sj_recyclechance(ids, 0).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("恢复成功");
							this.fn_tabledata();
							this.drawer_show = false;
						}
					});
				}
			},
			// ========================================================
			clear_drawer() {
				this.dailyRecord = [] // 编辑前的字段 ，用于判断是否修改过
				this.drawer_info = '' // 详情所有信息
				this.currentDetail_info = '' // 用于弹窗的字段
				this.editfieldlist = [] // 用于编辑的字段
				this.currentpup_id = '' // 当前详情id
				this.isTableShow = false
				this.field_details = []
				this.savenew = true
				this.edit_show = false
				this.turnisload = false
				this.savelist = []
				this.customer_obj = {
					id: "",
					name: "",
				};
				this.chance_obj = {
					id: "",
					name: "",
				};
				this.product_obj = { // 产品信息
					list: [],
					field_id: '',
				}
				this.enclosure = { // 附件信息
					list: [],
					field_id: '',
				}
			},
			// 导出
			exportclick() {
				if (!retujudpower(this.is_powerExp)) return;
				exportExcel("#exportTab", "商机列表");
			},
			// 导入
			importclick() {
				if (!retujudpower(this.is_powerImp)) return;
			},
			// 关联产品修改保存
			saveproduct(e) {
				let list = e.list || []
				this.separateSave(list, '商机产品')
			},
			// 关联附件修改保存
			setupfile(e) {
				let list = e.list || []
				this.separateSave(list, '商机附件')
				this.enclosure.list = list
			},
			// 单独保存产品和附件
			separateSave(reslist, field) {
				this.savelist = retJSONArr(this.field_create) || [];
				let index = this.savelist.findIndex((v) => v.field_sign == field);
				if (index != -1 && this.savelist[index]) {
					// 设置修改数据
					this.savelist[index].content = reslist
					let resdata = this.fn_Savedatas()
					resdata.append('chance_id', this.currentpup_id);
					edit_businchance(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("编辑成功");
							this.savelist = []
						}
					});
				}
			},
			// 保存数据处理
			fn_Savedatas() {
				let currobj = this.savelist;
				let fd = new FormData();
				this.fn_circulatedata(fd, this.Referencearr)
				this.fn_circulatedata(fd, this.ReferenceTime, true)
				let assistant = this.findfont("协同人");
				if (assistant && assistant.length) {
					// 	否	string	协同人id	逗号间隔 加 逗号
					fd.append("assistant_member_id", assistant.join(",") + ",");
				}
				let newArr = Basics_field(currobj);
				fd.append("business_info", JSON.stringify(newArr));
				return fd;
			},
			// 设置post值
			fn_circulatedata(fd, cArr, isTime) {
				for (let i = 0; i < cArr.length; i++) {
					let {
						name,
						key
					} = cArr[i]
					let res_ = this.findfont(name) + ''
					if (res_ != undefined && res_ != '') {
						if (isTime) { // 时间日期
							let len = (res_ + "").length;
							let time_Res = len > 10 ? ((res_ + '').slice(0, 10) * 1) : res_;
							fd.append(key, time_Res);
						} else {
							fd.append(key, res_);
						}
					}
				}
			},
			findfont(field) {
				if (this.savelist.length) {
					let index = this.savelist.findIndex((v) => v.field_sign == field || v.field == field);
					if (index != -1) {
						return this.savelist[index].content;
					} else {
						return "";
					}
				}
			},
			separateChange(field, fselect, selVal){
				let flist = this.$fn_retjson(this.dailyRecord)
				let index1 = flist.findIndex((v) => v.field_sign == field)
				flist[index1].content = selVal
				let selArr = fselect.filter(r=>r.id == selVal) || []
				flist[index1].select_field = selArr[0] ? selArr[0].name : ''
				return flist
			},
			// 单独修改详情 状态
			setChanges(e, flag) {
				let field = ''
				let fselect = []
				if(flag == 1){
					field = '商机状态'
					fselect = this.chance_state
				}
				else if(flag == 2){
					field = '签约状态'
					fselect = this.statelist
				}
				let fieldlist = this.separateChange(field, fselect, e)
				let data = {
					flag: false,
					fieldlist,
				}
				this.edit_show = true
				this.fnCreateSave(data)
			},
			// 新建,编辑保存
			fnCreateSave(e) {
				let {
					flag,
					fieldlist
				} = e
				this.savelist = retJSONArr(fieldlist) || [];
				let resdata = this.fn_Savedatas()
				if (this.edit_show) { // 编辑 
					resdata.append('chance_id', this.currentpup_id);
					let edit_data = contrastDaily(this.dailyRecord, this.savelist, 1);
					if (edit_data) { // 操作日志
						resdata.append('edit_data', edit_data);
					}
					edit_businchance(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("编辑成功");
							this.field_create = [];
							this.drawer_show = false;
							this.createPup = false;
							this.edit_show = false
							this.fn_tabledata();
						}
					});
				} else { // 新建 
					add_business_chance(resdata).then((res) => {
						if (this.$handlereq(res)) {
							this.$alertMess("添加成功");
							this.field_create = [];
							if (flag) {
								this.createclick();
							} else {
								this.createPup = false;
								this.clear_drawer()
							}
							this.fn_tabledata();
						}
					});
				}
			},
			// 编辑点击
			fn_editdatas() {
				if (!retujudpower(this.is_powerEdit)) return;
				this.edit_show = true
				this.savenew = false
				this.billet_tit = '编辑商机'
				if (this.field_create.length) {
					this.createPup = true
				} else {
					this.fn_groupList()
				}
			},
			// 新建点击
			createclick() {
				if (!retujudpower(this.is_powerAdd)) return;
				this.billet_tit = '新建商机'
				this.edit_show = false
				this.savenew = true
				this.field_create = []
				this.fn_groupList()
			},
			// 获取字段分类
			fn_groupList(flag) {
				if (!this.classlist.length) {
					getgroupList(999, 1).then((res) => {
						if (this.$handlereq(res)) {
							let obj = res.result.data;
							for (let item of obj) {
								item.type = item.group_id;
							}
							this.classlist = obj
							this.getConfigfield()
						}
					});
				} else {
					this.getConfigfield()
				}
			},
			// 获取字段列表
			getConfigfield() {
				if (this.field_initial.length) { // 已获取到初始字段，不用再获取
					let obj = fn_retjson(this.field_initial)
					this.setField_detail(obj)
				} else { // 未获取到初始字段
					getBusinesslist(999, 1).then((res) => {
						if (res.code === 10000) {
							let obj = res.result.data || [];
							// 未修改的初始字段
							this.field_initial = fn_retjson(obj)
							this.setField_detail(obj)
						}
					})
				}
			},
			setField_detail(obj) {
				// 赋值改动字段
				this.handle_createField(obj)
				this.field_create = obj
				// 弹窗详情展示 不做修改
				if (this.isTableShow) {
					this.field_details = fn_retjson(obj)
					if(this.glopertype == 2) {
						this.drawer_show = false
						this.drawer_loading = true
						
						if (!retujudpower(this.is_powerEdit)) return;
						this.edit_show = true
						this.savenew = false
						this.billet_tit = '编辑商机'
						this.createPup = true
					}
					else {
						this.drawer_show = obj.length ? true : false;
						this.drawer_loading = !this.drawer_show;
					}
				} else {
					// 创建'编辑弹窗 是否弹出
					this.createPup = obj.length ? true : false;
					this.clear_drawer()
				}
			},
			// 处理新建字段  
			handle_createField(data) {
				this.turndata = [] // 转合同所需数据
				for (let item of data) {
					fn_newfield(item, false)
					item.is_show = item.state ? true : false;
					let field = item.field || item.field_sign;
					// required: 1 必填
					let requArr = ['商机名称', '商机状态', '签约状态', '商机客户', '商机联系人', '负责人']
					item.required = requArr.some(v => v == field) ? 1 : 0;
					// 详情信息
					if (this.editfieldlist.length) {
						let curid = item.field_id || item.id;
						let res1 = fn_findeditid(curid, this.editfieldlist, this.field_initial)
						if (res1) {
							item.content = res1.content
							item.select_field = res1.select_field
						}
					}
					// 单个赋值
					if (field == '商机名称') {
						item.field_type = 1
						if (this.drawer_info) {
							item.content = item.select_field = this.drawer_info.name
							this.turndata.push(item)
						}
					} else if (field == '商机状态') {
						item.field_type = 5
						item.is_table = true
						item.field_list = this.chance_state
						if (this.drawer_info && this.drawer_info.status) {
							item.content = this.drawer_info.status_id
							item.select_field = this.drawer_info.status.name || ''
						} else {
							item.content = this.chance_state[0] ? this.chance_state[0].id : '';
						}
					} else if (field == "签约状态") {
						item.field_type = 5;
						item.is_table = true
						item.field_list = this.statelist
						if (this.drawer_info) {
							let c_val = this.drawer_info.state
							item.content = c_val
							let f_index = this.statelist.findIndex(v => v.id == c_val)
							if (f_index != -1) {
								item.select_field = this.statelist[f_index].name || ''
							}
						} else {
							item.content = this.statelist[0] ? this.statelist[0].id : '';
						}
					} else if (field == '商机预算') {
						item.field_type = 4
						item.is_table = true
						if (this.drawer_info) {
							item.select_field = item.content = this.drawer_info.budget
							this.turndata.push(item)
						}
					} else if (field == '预计签约') {
						item.field_type = 3
						item.is_table = true
						if (this.drawer_info) {
							item.content = item.select_field = ToggleTime(this.drawer_info.signing_time)
							this.turndata.push(item)
						}
					} else if (field == '需求描述') {
						item.field_type = 2
						item.maxLength = 600;
						item.length = 3
						item.isdescribe = true
					
					} else if (field == "负责人") {
						item.character = true
						item.field_type = 5
						item.is_table = true
						item.field_list = this.memberlist
						if (this.drawer_info) {
							item.content = this.drawer_info.member_id
							item.select_field = this.drawer_info.member ? this.drawer_info.member.name : '';
							this.turndata.push(item)
						} else {
							item.content = localStorage.member_id * 1;
						}
					} else if (field == "协作人" || field == "协同人") {
						item.character = true
						item.field_type = 6
						item.is_table = true
						item.field_list = this.memberlist
						item.select_field = item.content = []
						if (this.drawer_info) {
							let assistant_arr1 = this.drawer_info.assistant_member_id ? this.drawer_info
								.assistant_member_id.split(',') : [];
							let assistant_arr2 = []
							for (let ass of assistant_arr1) {
								if (ass) {
									assistant_arr2.push(ass * 1)
								}
							}
							item.content = assistant_arr2
							if (this.memberlist.length && assistant_arr2.length) {
								let res_arr = []
								for (let val of assistant_arr1) {
									let arr1 = this.memberlist.filter(v => v.member_id == val)
									let name = arr1[0] ? arr1[0].name : '';
									if (name) {
										res_arr.push(name)
									}
								}
								item.select_field = res_arr.length ? res_arr.join('、') : '';

							} else {
								item.select_field = ''
							}
							this.turndata.push(item)
						}
					} else if (field == "商机客户") {
						item.trends = true
						item.character = true
						item.is_table = true
						item.field_type = 9
						item.field_list = []
						if (this.drawer_info && this.drawer_info.customer) {
							// is_lock == 1 在公海
							let c_id = this.drawer_info.customer.is_lock == 1 ? this.drawer_info.customer.name1 :
								this
								.drawer_info.customer_id;
							let c_name = this.drawer_info.customer ? this.drawer_info.customer.name1 : '';
							item.select_field = c_name
							item.content = c_id
							item.singleval = {
								id: c_id,
								name: c_name,
							}
							this.turndata.push(item)
						}
					} else if (field == "商机联系人") {
						item.trends = true
						item.character = true
						item.field_type = 10
						item.field_list = []
						if (this.drawer_info) {
							let c_name = this.drawer_info.contact ? this.drawer_info.contact.name1 : '';
							if (this.drawer_info.customer && this.drawer_info.customer.is_lock == 1) { // 在公海
								item.content = c_name
							} else {
								item.content = this.drawer_info.contact_id
							}
							item.select_field = c_name
						}
					} else if (field == '商机附件') {
						item.field_type = 7
						if (!this.drawer_info) {
							item.content = []
						} else {
							this.turndata.push(item)
						}
					} else if (field == '商机产品') {
						item.field_type = 20
						if (!this.drawer_info) {
							item.content = []
						} else {
							this.turndata.push(item)
						}
					}


				}
				this.dailyRecord = JSON.parse(JSON.stringify(data))
			},
			//
			clearfilter() {
				this.search_member = []
				this.assistantMember = []
				this.customer_search = []
				this.search_time = ''
				this.search_edit_time = ''
			},
			// 筛选条件列表更新 filterpuplist
			setfntable(e) {
				this.clearfilter()
				if (e && e.list) {
					let reslist = retJSONArr(e.list)
					this.setcustomfil(reslist)
					this.FilterList = reslist.length ? fn_retjson(reslist) : fn_retjson(this.defFilter); // 筛选条件列表
				}
				this.fn_tabledata();
			},
			setcustomfil(reslist){
				for (let item of reslist) {
					let {
						lv1_selVal,
						lv2_selVal,
						lv3_selVal
					} = item
					if (lv1_selVal == 0) {} // 创建人
					if (lv1_selVal == 1) { // 负责人
						this.search_member = lv3_selVal || []
					}
					if (lv1_selVal == 2) { // 协同人
						this.assistantMember = lv3_selVal || []
					}
					if (lv1_selVal == 3) { // 客户
						this.customer_search = lv3_selVal || []
					}
					if (lv1_selVal == 4) { // 添加时间
						let restime = headleTime(lv3_selVal, lv2_selVal)
						this.search_time = restime
					}
					if (lv1_selVal == 5) { // 更新时间
						let restime = headleTime(lv3_selVal, lv2_selVal)
						this.search_edit_time = restime
					}
				}
			},
			// 下拉筛选改变 1693497600,1694361600
			fn_screen(e) {
				if (e) {
					// 固定筛选值
					this.search_name = e.search_name || ''
					this.sort_type = e.sort_type || 1
					// 不确定筛选值
					this.screVal1 = e.status || []
					this.screVal2 = e.state || []
					this.fn_tabledata();
				}
			},
			// 视图选择更新
			uprenew(e) {
				if (e && e.view_operate) { // 视图配置
					this.remoteviewOperate = retJSONArr(e.view_operate)
					this.clearSrceen()
					this.executeViewOperate();
				}
			},
			clearSrceen() {
				this.screVal1 = [];
				this.screVal2 = [];
				this.search_time = '';
				this.search_edit_time = '';
				this.search_name = "";
				this.search_member = [];
				this.customer_search = []
				this.assistantMember = [];
				this.sort_type = 1
			},
			// 执行视图配置   this.List  筛选条件
			executeViewOperate() {
				// 全部清空筛选
				if (this.remoteviewOperate.operate != 100) { // 系统视图
					if (this.$refs.refader) {
						this.$refs.refader.clearScreen()
					}
					this.class_type = this.remoteviewOperate.operate - 1;
					this.FilterList = fn_retjson(this.defFilter)
					this.fn_tabledata();

				} else { // 用户创建视图
					if (this.remoteviewOperate.class_type === undefined) {
						if (this.$refs.refader) {
							this.$refs.refader.clearScreen()
							this.FilterList = fn_retjson(this.defFilter)
						}
						this.class_type = 0;
						this.fn_tabledata();
					} else {
						let obj = this.remoteviewOperate
						this.class_type = fn_retjson(obj.class_type) // 资源类型
						this.screVal1 = fn_retjson(obj.status) // 
						this.screVal2 = fn_retjson(obj.state) // 
						

						this.search_name = fn_retjson(obj.search_name) // 搜索名称
						this.FilterList = fn_retjson(obj.List) // 筛选条件列表
						this.sort_type = fn_retjson(obj.sort_type) // 排序
						this.search_member = fn_retjson(obj.search_member) // 负责人
						if(obj.List) {
							this.setcustomfil(obj.List)
						}
						let flag_ = deepStrs(this.defFilter, this.FilterList)
						// 当前筛选列表不等于默认列表
						if (!flag_) {
							this.fn_tabledata();
						}
					}
				}
			},
			// 获取当前本地视图配置
			fn_localView() {
				this.localviewOperate = {
					operate: 100,
					class_type: this.class_type,
					status: this.screVal1,
					state: this.screVal2,
					search_name: this.search_name,
					List: this.FilterList,
					sort_type: this.sort_type,
					search_member: this.search_member,
				};
			},
			// 执行搜索
			fn_tabledata() {
				if (this.table_loading) return
				if (this.glopertype) return
				this.table_loading = true;
				this.fn_localView();
				// 判断是否为新视图，或者视图是否有修改
				this.JudgmentOpen();
				let data = {
					sort_type: this.sort_type, //  否	string	排序类型 1:最新释放2:最新创建3:最新访问4:最新跟进
					pagesize: this.datapage.pagesize, //  	是	int	每页数量
					page: this.datapage.page,
					is_recycle: this.is_recycle,
					class_type: this.class_type || 0, // 资源类型  1:我负责的2:我协同的3:下属负责
				};
				let search_val = (this.search_name + '').trim()
				if (search_val) { // 搜索名称
					data.search_name = search_val;
				}
				if (this.screVal1.length) { // 
					data.status_id = this.screVal1.join(",")
				}
				if (this.screVal2.length) { // 
					data.state = this.screVal2.join(",")
				}
				
				if (this.search_time) { // 添加时间 search_time
					data.create_time = this.search_time
				}
				if (this.search_edit_time) { // 更新时间
					data.edit_time = this.search_edit_time
				}
				if (this.search_member.length) { // 负责人
					data.member_id = this.search_member.join(",");
				}
				if (this.assistantMember.length) { // 协同人
					data.assistant_member_id = this.assistantMember.join(",");
				}
				if (this.customer_search.length) { //客户
					data.customer_id = this.customer_search.join(",");
				}
				gchance_list(data).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result.data;
					this.handle_data(obj);
					let total = res.result.total;
					this.datapage.total = total
					this.table_loading = false;
					if(this.searchshow) {
						this.$emit('echototal', {total}) 
					}
				});
			},
			// 处理数据
			handle_data(data) {
				if (data) {
					for (let item of data) {
						let new_obj = retJSONArr(item.business_info)
						if (new_obj && new_obj.length) {
							let index = new_obj.findIndex((v) => v.field_sign == "商机预算");
							if (index != -1) {
								item.budget = formatCurrency(new_obj[index].content);
							}
						}
						item.state_txt = item.state ? '已签约' : '未签约';
						let cust_obj = retJSONArr(item.customer_info)
						if(item.qy_name) {
							item.eqy_name = item.qy_name
						}
						else {
							if (cust_obj && cust_obj.length) {
								let index2 = cust_obj.findIndex((v) => v.field_sign == "企业名称" || v.field == "企业名称");
								if (index2 != -1) {
									item.eqy_name = cust_obj[index2].content;
								}
							}
						}
					}
					this.datapage.list = data;
				}
			},
			// -----------------------------------------------------------
			setsaveBtn(flag) {
				if (this.$refs.refader) {
					this.$refs.refader.setSaveBtn(flag)
				}
			},
			setnewBtn(flag) {
				if (this.$refs.refader) {
					this.$refs.refader.setNewBtn(flag)
				}
			},
			//判断视图按钮是否打开
			JudgmentOpen() {
				let cobj = fnCustomPage("project");
				let findobj = {
					localviewOperate: this.localviewOperate,
					remoteviewOperate: this.remoteviewOperate,
					defFilter: this.defFilter,
					FilterList: this.FilterList,
					screVal1: this.screVal1,
					screVal2: this.screVal2,
					search_name: this.search_name,
					sort_type: this.sort_type,
					def_sort: cobj.sort,
				}
				let resobj = fn_Judgmentbtn(findobj)
				let {customflag, systemflag} = resobj
				if(customflag) { // 用户创建的视图
					this.setsaveBtn(customflag) 
				}
				else {  // 系统视图
					this.setnewBtn(systemflag) 
				}
			},
			// 详情点击
			showDetails(e) {
				let {
					row
				} = e;
				if (row.chance_id) {
					// 当前点击的id
					this.currentpup_id = row.chance_id;
					this.fn_getDelait();
				}
			},
			// 划窗刷新
			fn_update() {
				this.field_details = []
				this.fn_getDelait();
			},
			
			// 获取详情  组件: detailspup
			fn_getDelait() {
				this.drawer_loading = true;
				Chance_details(this.currentpup_id).then((res) => {
					if (!this.$handlereq(res)) return
					let obj = res.result || '';
					if (!obj) return;
					// 用于弹窗的字段   status
					this.currentDetail_info = JSON.stringify(obj)
					this.Detail_scre1 = obj.status ? obj.status.status_id : ''
					this.Detail_scre2 = obj.state
					
					// 字段信息 
					let parse_info = retJSONArr(obj.business_info)
					if (parse_info.length) {
						let index1 = parse_info.findIndex((v) => v.field_sign == "商机产品");
						if (index1 != -1) {
							let c_content = parse_info[index1].content || []
							this.product_obj.list = retJSONArr(c_content) || []
							this.product_obj.field_id = parse_info[index1].field_id;
						}
						let index2 = parse_info.findIndex((v) => v.field_sign == "商机附件");
						if (index2 != -1) {
							let c_content = parse_info[index2].content || []
							this.enclosure.list = retJSONArr(c_content) || []
							this.enclosure.field_id = parse_info[index2].field_id;
						}
					}
					// 用于编辑的字段
					this.editfieldlist = fn_retjson(parse_info);
					// 详情所有信息
					this.drawer_info = obj;
					this.chance_obj = {
						id: obj.chance_id,
						name: obj.name,
					};
					this.isTableShow = true
					this.fn_groupList()
					
					// 信息
					this.stablelist = [
						{
							field: '客户',
							character: true,
							select_field: obj.customer ? obj.customer.name1 : '',
						},
						{
							field: '企业名',
							select_field: obj.customer ? obj.customer.qy_name : '',
						},
						{
							field: '负责人',
							character: true,
							select_field: obj.member ? obj.member.name : '',
						},
						{
							field: '商机预算',
							select_field: obj.budget || '',
						},
						{
							field: '商机状态',
							select_field: obj.status ? obj.status.name : '',
						},
						{
							field: '签约状态',
							select_field: obj.state ? '已签约' : '未签约',
						},
						{
							field: '添加时间',
							select_field: obj.create_time || '',
						},
						{
							field: '预计签约',
							select_field: obj.signing_time || '',
						},
						{
							field: '最后跟进时间',
							select_field: obj.follow_time || '',
						},
					]
				});
			},
			modify_pagesize(e) {
				let {
					val
				} = e;
				this.datapage.page = 1;
				this.datapage.pagesize = val;
				this.fn_tabledata();
			},
			switch_page(e) {
				let {
					val
				} = e;
				this.datapage.page = val;
				this.fn_tabledata();
			},
			// -----------------------------------
			//获取成员列表
			getMumberList() {
				getMumberUser().then((res) => {
					if (res.code == 1000) {
						let obj = res.result || [];
						for (let item of obj) {
							item.id = item.member_id
						}
						this.memberlist = obj
						this.filterpuplist = saleconditions(obj)
						this.filterpuplist.length = 5
						this.getStateSelect()
					}
				});
			},
			// 获取 全部商机状态 下拉列表
			getStateSelect() {
				getstatusList().then((res) => {
					if (res.code == 10000) {
						let obj = res.result.data;
						for (let item of obj) {
							item.id = item.status_id;
						}
						this.chance_state = obj;
					}
				});
			},
		},
		data() {
			return {
				
				stablelist: [],
				surplus: 600,
				// 权限
				is_powerAdd: false,  // 新增
				is_powerEdit: false,  // 编辑
				is_powerDel: false,  // 删除
				is_powerImp: false,  // 导入
				is_powerExp: false,  // 导出
				is_powerRec: false,  // 回收站
				powerobj: '',
				// ---
				pageshow: false, // 当前页面是否能正常显示
				product_obj: { // 产品信息
					list: [],
					field_id: '',
				},
				enclosure: { // 附件信息
					list: [],
					field_id: '',
				},
				turndata: [], // 转合同数据
				turnisload: false, // 转合同是否打开
				write_show: false, // 跟进是否打开
				chance_obj: { // 商机信息
					id: "",
					name: "",
				},
				customer_obj: { // 客户信息
					id: "",
					name: "",
				},
				batch_edit: false, // 是否批量修改
				collab_show: false, // 转让\添加协同人是否打开
				assistantChecklist: [], // 转让\添加协同人  已选中项
				BatchType: 1, // 1.单选  2.多选
				dialogname: '', // 转让\添加协同人 弹窗名称
				sortlist: [{ // 排序列表
						id: 1,
						name: '按最新创建排序',
					},
					{
						id: 2,
						name: '按最新跟进排序',
					},
					{
						id: 3,
						name: '按最早跟进排序',
					},
					{
						id: 4,
						name: '按商机预算排序',
					},
				],
				billet_tit: '新建商机',
				// 不确定筛选值
				screVal1: [],
				screVal2: [],
				is_recycle: 0, // 是否为回收站
				statelist: [{ // 签约状态 
						id: 0,
						name: "未签约",
					},
					{
						id: 1,
						name: "已签约",
					},
				], 
				chance_state: [], // 商机状态
				edit_show: false, // 是否为编辑状态
				classlist: [], // 字段分类
				field_initial: [], //  未处理过的字段信息
				field_create: [], // 未保存的 字段数据
				savelist: [], // 保存时的 字段数据
				dailyRecord: [], // 编辑前的字段 ，用于操作日志
				drawer_info: '', // 详情所有信息
				currentDetail_info: '', // 用于弹窗的字段
				Detail_scre1: '',  // 单独修改商机状态
				Detail_scre2: '',  // 单独修改签约状态
				editfieldlist: [], // 用于编辑的字段
				currentpup_id: '', // 当前详情id
				isTableShow: false, // 是否为详情推出详细
				field_details: [], // 详情推出详细数据
				savenew: true, // 是否新建再保存
				drawer_show: false, // 详情划窗是否显示
				drawer_loading: true, // 详情划窗是否加载完成
				createPup: false, // 新建、编辑弹窗 是否显示
				Referencearr: [{ // 新建、编辑时，所需传参
						key: 'name',
						name: '商机名称',
					},
					{
						key: 'customer_id',
						name: '商机客户',
					},
					{
						key: 'contact_id',
						name: '商机联系人',
					},
					{
						key: 'status_id',
						name: '商机状态',
					},
					{
						key: 'state',
						name: '签约状态',
					},
					{
						key: 'member_id',
						name: '负责人',
					},
					{
						key: 'budget',
						name: '商机预算',
					},
				],
				ReferenceTime: [{ // 新建、编辑时，所需时间传参
					key: 'signing_time',
					name: '预计签约',
				}, ],
				// =============================================  
				memberlist: [], // 成员列表
				table_loading: false, // 列表加载
				// 
				search_member: [], // 负责人 筛选
				assistantMember: [], // 协同人 筛选
				customer_search: [], // 客户 筛选
				search_time: '', // 添加时间 筛选
				search_edit_time: '', // 更新时间 筛选
				class_type: 0, //	类型 筛选
				search_name: '', // 搜索名称 筛选
				sort_type: 1, // 排序 筛选
				// 
				FilterList: [{ // 当前筛选条件弹窗列表
					lv1_selVal: null,
					lv2_selVal: null,
					lv3_selVal: null,
				}, ],
				defFilter: [{ // 默认空白筛选条件
					lv1_selVal: null,
					lv2_selVal: null,
					lv3_selVal: null,
				}, ],
				filterpuplist: [], // 筛选弹出项
				localviewOperate: {}, // 当前视图配置
				remoteviewOperate: {}, // 当前执行视图配置
				// 列表
				datapage: {
					pagesize: 50,
					page: 1,
					total: 0,
					list: [],
				},
				check_list: [], // 列表多选
				customPageSize: 50, // 列表默认页数
			 
				tableColumn: [{ // 表头
						name: '商机名称',
						prop: 'name',
						width: 300,
					},
					{
						prop: 'status_stage',
						name: '商机状态',
					},
					{
						prop: 'state_txt',
						name: '签约状态',
					},
					{
						prop: 'contact_name',
						name: '联系人',
					},
					{
						prop: 'customer_name',
						name: '所属客户',
					},
					{
						prop: 'eqy_name',
						name: '所属企业',
						width: 300,
					},
					{
						prop: 'member_name',
						name: '负责人',
					},
					{
						prop: 'create_time',
						name: '添加时间',
					},
					{
						prop: 'creator_name',
						name: '创建人',
					},
					{
						prop: 'budget',
						name: '商机预算',
					},
				],
				// 
			}
		},
	}
</script>

<style lang="scss" scoped>
	@import "@/assets/css/public.scss";
</style>